<template lang="pug">
.parametros-estado-formulario
    BaseHeader(
        :titulo='$t("configuracaoParametros.formulario.titulo.estado")',
        voltarPara
    )
    .parametros-estado-formulario__container
        .parametros-estado-formulario__titulo
            h3
                | {{ obterTituloFormulario() }}
        el-form.parametros-estado-formulario__form(
            label-position='top',
            size='default',
            :model='configuracao',
            :rules='regras',
            :hide-required-asterisk='true',
            ref='parametrosEstadoFormularioRef'
        )
            span.parametros-estado-formulario__info
                | {{ $t('configuracaoParametros.formulario.infoFormulario.estado') }}
            el-form-item.required(
                :label='$t("configuracaoParametros.formulario.campoEstado")',
                prop='idEstado'
            )
                el-select(
                    v-model='configuracao.idEstado',
                    :placeholder='$t("configuracaoParametros.formulario.placeholderEstado")',
                    clearable,
                    filterable
                )
                    el-option(
                        v-for='estado in estados',
                        :key='estado.id',
                        :label='estado.nome',
                        :value='estado.id'
                    )
            el-form-item.required(
                :label='$t("configuracaoParametros.formulario.campoDistanciaRaioKm")',
                prop='distanciaRaioKm'
            )
                el-input(
                    type='number',
                    v-model='configuracao.distanciaRaioKm',
                    :placeholder='$t("configuracaoParametros.formulario.placeholderDistanciaRaioKm")',
                    @keydown='handleKeydownInputNumber'
                )
            el-form-item(
                :label='$t("configuracaoParametros.formulario.campoPorExcCapProdutiva")',
                prop='percentualCapacidadeProdutiva'
            )
                el-input(
                    type='number',
                    v-model='configuracao.percentualCapacidadeProdutiva',
                    :placeholder='$t("configuracaoParametros.formulario.placeholderCampoPorExcCapProdutiva")',
                    disabled,
                    @keydown='handleKeydownInputNumber'
                )
        .parametros-estado-formulario__footer
            el-button(@click='voltarConfiguracao')
                i.mdi.mdi-arrow-left
                span Voltar
            el-button(type='primary', @click='submeterParametros')
                span Salvar
                i.mdi.mdi-arrow-right
</template>

<script>
import services from '@/services/ConfiguracaoRastreabilidadeService';
import LocalidadeService from '@/services/LocalidadeService';
import { handleKeydownInputNumber } from '@/views/contratos-originacao/parametros/utils';
import {
    cadastrarParametros,
    editarParametros
} from '@/views/contratos-originacao/parametros/services/configuracaoEstadoService';
import regras from '@/views/contratos-originacao/parametros/utils/assets/regrasFormularioEstado';

export default {
    name: 'ParametrosEstadoFormulario',
    components: {
        BaseHeader: () => import('@/components/BaseHeader')
    },
    data() {
        return {
            regras,
            estados: [],
            configuracao: {
                idEstado: null,
                distanciaRaioKm: null,
                percentualCapacidadeProdutiva: 15
            }
        };
    },
    mounted() {
        this.buscarDados();
        this.buscarEstados();
    },
    computed: {
        formRef() {
            return this.$refs.parametrosEstadoFormularioRef;
        }
    },
    methods: {
        handleKeydownInputNumber,
        obterTituloFormulario() {
            return this.$route.params?.idConfiguracaoRastreabilidade
                ? this.$t(
                      'configuracaoParametros.formulario.tituloFormularioEdicao.estado'
                  )
                : this.$t(
                      'configuracaoParametros.formulario.tituloFormularioCadastro.estado'
                  );
        },
        voltarConfiguracao() {
            this.$router.push({ name: 'ParametrosEstado' });
        },
        buscarEstados() {
            LocalidadeService.findEstados()
                .then(({ data }) => {
                    this.estados = data;
                })
                .catch(() => {
                    this.$notify.error(
                        this.$t('mensagens.sistema.erroBuscarEstados')
                    );
                });
        },
        buscarConfiguracaoPadrao() {
            return services
                .buscarConfiguracaoRastreabilidadePadrao()
                .then(({ data }) => {
                    if (data) {
                        this.configuracao.distanciaRaioKm =
                            data.distanciaRaioKm;
                        this.configuracao.percentualCapacidadeProdutiva =
                            data.percentualCapacidadeProdutiva;
                    }
                })
                .catch(() => {
                    this.$notify.error(
                        this.$t(
                            'configuracaoParametros.erro.erroBucaConfiguracaoPadrao'
                        )
                    );
                });
        },
        buscarDados() {
            const id = this.$route.params?.idConfiguracaoRastreabilidade;

            if (id) {
                services
                    .findById(id)
                    .then(({ data }) => {
                        if (data) {
                            this.configuracao.id = data?.id;
                            this.configuracao.idEstado = data?.idEstado;
                            this.configuracao.distanciaRaioKm =
                                data?.distanciaRaioKm;
                            this.configuracao.percentualCapacidadeProdutiva =
                                data?.percentualCapacidadeProdutiva;
                        }
                    })
                    .catch(() => {
                        this.$notify.error(
                            this.$t(
                                'configuracaoParametros.erro.erroBuscarDados'
                            )
                        );
                    });
            } else {
                this.buscarConfiguracaoPadrao();
            }
        },
        editarParametros() {
            editarParametros(this.configuracao).then(() => {
                this.$notify.success(
                    this.$t('configuracaoParametros.sucesso.sucessoEditarDados')
                );
                this.voltarConfiguracao();
            });
        },
        cadastrarParametros() {
            cadastrarParametros(this.configuracao).then(() => {
                this.$notify.success(
                    this.$t(
                        'configuracaoParametros.sucesso.sucessoCadastrarDados'
                    )
                );
                this.voltarConfiguracao();
            });
        },
        submeterParametros() {
            this.formRef.validate(valid => {
                if (valid) {
                    if (this.configuracao.id) {
                        this.editarParametros();
                    } else {
                        this.cadastrarParametros();
                    }
                }
            });
        }
    }
};
</script>

<style lang="scss">
.parametros-estado-formulario {
    &__container {
        margin: 20px;
    }
    &__titulo {
        margin-top: 20px;
    }
    &__form {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-top: 20px;
        padding: 20px;
        background-color: var(--white);
        border-radius: $default-border-radius;
        @include default-box-shadow();
    }
    &__info {
        color: var(--gray);
    }
    &__footer {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }

    .el-form-item {
        width: 50%;
        display: flex;
        flex-direction: column;
        gap: 4px;
        &.required > .el-form-item__label {
            &::after {
                content: '*';
                margin-left: 2px;
                color: red;
            }
        }
        &__label {
            line-height: 1;
        }
        .el-select {
            width: 100%;
        }
        .el-input {
            width: 100%;
            height: 42px;
            outline: none;
            border: 1px solid $default-border-color;
            border-radius: $default-border-radius;
            &:hover,
            &:focus {
                border: 1px solid $primary;
            }
            & input {
                color: var(--primary) !important;
                outline: none;
                border: none;
                &:disabled {
                    color: #545454 !important;
                }
            }
        }
    }
    .el-button {
        &--primary {
            &:focus {
                color: var(--white);
            }
        }
        &--default {
            background-color: transparent;
            color: var(--primary);
            border: 1px solid var(--primary);
            &:hover {
                background-color: var(--primary);
                color: var(--white);
            }
        }
    }
}
</style>
